//useTypewriter.js
import { useState, useEffect } from 'react';


export default function useTypewriter(text, speed = 30, delay = 0) {
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!text) return;

    // Reset state when text changes
    setDisplayed('');
    setDone(false);

    const timeout = setTimeout(() => {
      let i = 0;
      const interval = setInterval(() => {
        setDisplayed(text.substring(0, i + 1)); // Use substring instead of accumulating
        i++;
        if (i >= text.length) {
          clearInterval(interval);
          setDone(true);
        }
      }, speed);

      // Return cleanup function for the interval
      return () => clearInterval(interval);
    }, delay);

    // Cleanup timeout
    return () => clearTimeout(timeout);
  }, [text, speed, delay]);

  return done ? displayed : displayed + '▌';
}